// Phase 3 — buddy/carpool-seat request API. One REQUEST entity, distinguished by requestType.
import client from "./client";

export const fetchRequests = () => client.get("/requests").then((r) => r.data);

export const createRequest = (request) => client.post("/requests", request).then((r) => r.data);

export const updateRequest = (requestId, action) =>
  client.put(`/requests/${requestId}`, { action }).then((r) => r.data);
